import Load from 'components/Load';
import { createNavigationalRoute } from 'modules/app/components/NavigationalLayout';
import React from 'react';
import { Route } from 'react-router-dom';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';

const AsyncWriteAReview = Load(
  () =>
    import(
      /* webpackChunkName: "write-review" */ './containers/WriteAReviewContainer'
    ),
);

const AsyncWriteAReviewUnauthenticatedContainer = Load(
  () =>
    import(
      /* webpackChunkName: "write-review" */ './containers/WriteAReviewUnauthenticatedContainer'
    ),
);

const AsyncSuggestionsContainer = Load(
  () =>
    import(
      /* webpackChunkName: "write-review" */ './containers/SuggestionsContainer'
    ),
);
const AsyncFeedbackContainer = Load(
  () =>
    import(
      /* webpackChunkName: "write-review" */ './containers/FeedbackContainer'
    ),
);

const AsyncFeedbackUnauthenticatedContainer = Load(
  () =>
    import(
      /* webpackChunkName: "write-review" */ './containers/FeedbackUnauthenticatedContainer'
    ),
);

const AsyncSuggestionsUnauthenticatedContainer = Load(
  () =>
    import(
      /* webpackChunkName: "write-review" */ './containers/SuggestionsUnauthenticatedContainer'
    ),
);

const base = `${basePath}/manage/review`;

const descriptor = (
  id: string,
  suffix: string,
  label: string,
): RouteDescriptor => ({
  id,
  path: `${base}${suffix}`,
  label,
  audience: 'both',
  layout: 'navigational',
  module: 'write-review',
});

export const writeReviewSuggestionsRoute = descriptor(
  'write-review.suggestions',
  '/:tripId/suggestions',
  'Review Suggestions',
);
export const writeReviewFeedbackRoute: RouteDescriptor = {
  id: 'write-review.feedback',
  path: `${base}/:tripId/feedback`,
  label: 'Review Feedback',
  audience: 'both',
  layout: 'standalone',
  module: 'write-review',
};
export const writeReviewSuggestionsUnauthRoute = descriptor(
  'write-review.suggestions-unauth',
  '/:tripId/:accountId/suggestions',
  'Review Suggestions (Guest)',
);
export const writeReviewFeedbackUnauthRoute: RouteDescriptor = {
  id: 'write-review.feedback-unauth',
  path: `${base}/:tripId/:accountId/feedback`,
  label: 'Review Feedback (Guest)',
  audience: 'both',
  layout: 'standalone',
  module: 'write-review',
};
export const writeReviewUnauthRoute: RouteDescriptor = {
  id: 'write-review.detail-unauth',
  path: `${base}/:tripId/:accountId`,
  label: 'Write Review (Guest)',
  audience: 'both',
  layout: 'standalone',
  module: 'write-review',
};
export const writeReviewRoute: RouteDescriptor = {
  id: 'write-review.detail',
  path: `${base}/:tripId`,
  label: 'Write Review',
  audience: 'both',
  layout: 'standalone',
  module: 'write-review',
};

export const writeReviewRoutes = [
  createNavigationalRoute({
    key: writeReviewSuggestionsRoute.id,
    id: writeReviewSuggestionsRoute.id,
    nonFixedNavbar: true,
    path: writeReviewSuggestionsRoute.path,
    component: AsyncSuggestionsContainer,
    hideFooter: true,
    showBottomNavigation: true,
    handle: createRouteHandle(writeReviewSuggestionsRoute),
  }),
  <Route
    key={writeReviewFeedbackRoute.id}
    id={writeReviewFeedbackRoute.id}
    path={writeReviewFeedbackRoute.path}
    handle={createRouteHandle(writeReviewFeedbackRoute)}
    element={<AsyncFeedbackContainer />}
  />,
  createNavigationalRoute({
    key: writeReviewSuggestionsUnauthRoute.id,
    id: writeReviewSuggestionsUnauthRoute.id,
    nonFixedNavbar: true,
    path: writeReviewSuggestionsUnauthRoute.path,
    component: AsyncSuggestionsUnauthenticatedContainer,
    hideFooter: true,
    showBottomNavigation: true,
    handle: createRouteHandle(writeReviewSuggestionsUnauthRoute),
  }),
  <Route
    key={writeReviewFeedbackUnauthRoute.id}
    id={writeReviewFeedbackUnauthRoute.id}
    path={writeReviewFeedbackUnauthRoute.path}
    handle={createRouteHandle(writeReviewFeedbackUnauthRoute)}
    element={<AsyncFeedbackUnauthenticatedContainer />}
  />,
  <Route
    key={writeReviewUnauthRoute.id}
    id={writeReviewUnauthRoute.id}
    path={writeReviewUnauthRoute.path}
    handle={createRouteHandle(writeReviewUnauthRoute)}
    element={<AsyncWriteAReviewUnauthenticatedContainer />}
  />,
  <Route
    key={writeReviewRoute.id}
    id={writeReviewRoute.id}
    path={writeReviewRoute.path}
    handle={createRouteHandle(writeReviewRoute)}
    element={<AsyncWriteAReview />}
  />,
];

export const writeReviewRouteDescriptors = [
  writeReviewSuggestionsRoute,
  writeReviewFeedbackRoute,
  writeReviewSuggestionsUnauthRoute,
  writeReviewFeedbackUnauthRoute,
  writeReviewUnauthRoute,
  writeReviewRoute,
];

export default writeReviewRoutes;
